const analyzeImage = document.querySelector('.analyze-whoNeed');
const analyzeFilterBnt = document.querySelectorAll('.analyze-whoNeed__filter .btn');

const setImage = (index) => analyzeImage.style.backgroundImage = `url('/static/assets/img/bgs/filter/bitmap${index}.jpg')`

export const setFilterImage = () => analyzeFilterBnt.forEach((button, buttonIndex) => {
    button.addEventListener('click', (e) => setImage(buttonIndex))
})